import { TeamMemberType } from '../enums';
import { UserInfo } from '../interfaces';

const isTeamAdminUser = (userInfo: UserInfo) => {
  const type = userInfo?.accountDetails?.teamMemberType;
  return type === TeamMemberType.administrator || type === TeamMemberType.owner;
};

export default isTeamAdminUser;
